var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudiciary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}.cls-2{fill:none;stroke:#b7b7b7;stroke-miterlimit:10;stroke-width:0.75px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.78,
    y: 4.19,
    width: 7.42,
    height: 0.78,
    rx: 0.39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.51,7.72A1.58,1.58,0,0,1,11,9.38,1.58,1.58,0,0,1,9.57,7.72C9.57,6.8,11,4.91,11,4.91S12.51,6.8,12.51,7.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.43,7.72A1.58,1.58,0,0,1,4,9.38,1.58,1.58,0,0,1,2.49,7.72C2.49,6.8,4,4.91,4,4.91S5.43,6.8,5.43,7.72Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.47,
    y: 7.26,
    width: 2.97,
    height: 0.78,
    rx: 0.39
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.56,
    y: 7.26,
    width: 2.97,
    height: 0.78,
    rx: 0.39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.74,
    y: 11.95,
    width: 7.42,
    height: 0.78,
    rx: 0.39
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.28,
    y: 7.06,
    width: 10.35,
    height: 0.78,
    rx: 0.39,
    transform: "translate(14.9 0) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudiciary);
export default __webpack_public_path__ + "static/media/judiciary.76e075e94329d8f9df48201b3b6e608c.svg";
export { ForwardRef as ReactComponent };